export const environment = {
  production: false,
  //   apiUrl: 'http://localhost:3001',
  storagePrefix: 'SMART_POS',
  apiUrl: 'https://api.admin.farm-run.dev.riseplus.tech',
  tileLayerUrl: 'https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=D5I42pL1teP7CJsdiXli',
};
